import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Passport } from 'src/types/Passport';

interface DeliveryReportState {
  bindedPassports: Passport[];
}

const initialState: DeliveryReportState = {
  bindedPassports: []
};

const slice = createSlice({
  name: 'deliveryReport',
  initialState,
  reducers: {
    bindPassports(
      state: DeliveryReportState,
      action: PayloadAction<Passport[]>
    ) {
      const { bindedPassports } = state;

      const bindedIds = bindedPassports.map((passport) => passport.id);

      const newPassports = action.payload.filter(
        ({ id }) => !bindedIds.includes(id)
      );

      state.bindedPassports.push(...newPassports);
    },
    unbindPassport(
      state: DeliveryReportState,
      action: PayloadAction<{ passportId: number }>
    ) {
      const { bindedPassports } = state;
      const { passportId } = action.payload;

      const newPassports = bindedPassports.filter(
        ({ id }) => passportId !== id
      );

      state.bindedPassports = newPassports;
    },
    clearReportState(
      state: DeliveryReportState
    ) {
      state.bindedPassports = [];
    }
  }
});

export const { reducer } = slice;

export const {
  bindPassports,
  unbindPassport,
  clearReportState
} = slice.actions;

export default slice;
